export default __webpack_public_path__ + "static/media/dtsu5168_ct_gw152.92cb5be4.jpg";